import React from 'react'
import PropTypes from "prop-types";
import { Helmet } from 'react-helmet-async';

const DEFAULT_OG_IMAGE = "https://itcodeinfotech.com/images/og-default.jpg";

const SEO = (props) => {
    const {metaTitle,title,ogDescription,metaDescription,metaRobots,canonicalTag,ogTitle,ogType,ogImage,ogUrl} = props
    const resolvedOgImage = ogImage || DEFAULT_OG_IMAGE;
    const resolvedTitle = metaTitle || title || "ITCODE InfoTech";
    return (
        <Helmet>
             <title>{resolvedTitle}</title>
          {metaDescription ? (
            <meta name="description" content={metaDescription} />
          ) : (
            ""
          )}
          {metaRobots ? (
            <meta name="robots" content={metaRobots} />
          ) : (
            ""
          )}
          {canonicalTag ? (
            <link rel="canonical" href={canonicalTag} />
          ) : (
            ""
          )}
          {ogTitle ? (
            <meta property="og:title" content={ogTitle} />
          ) : (
            ""
          )}
          {ogType ? (
            <meta property="og:type" content={ogType} />
          ) : (
            ""
          )}
          <meta property="og:image" content={resolvedOgImage} />
          {ogUrl ? (
            <meta property="og:url" content={ogUrl} />
          ) : (
            ""
          )}
          {ogDescription ? (
            <meta
              property="og:description"
              content={ogDescription}
            />
          ) : (
            ""
          )}
          <meta name="twitter:card" content="summary_large_image" />
          {ogTitle ? (
            <meta name="twitter:title" content={ogTitle} />
          ) : (
            ""
          )}
          {ogDescription ? (
            <meta name="twitter:description" content={ogDescription} />
          ) : (
            ""
          )}
          <meta name="twitter:image" content={resolvedOgImage} />
        </Helmet>
    )
}
SEO.propTypes = {
    metaTitle: PropTypes.string,
    title: PropTypes.string
};

export default SEO;
